import React, { useContext, useState, useEffect } from 'react';

import { Marker } from 'react-leaflet';
import { Point, Icon } from 'leaflet';

import { HighlightedAddressState } from '@atlas/types';
import { AtlasEventsContext } from '@atlas/contexts/events';
import { SearchContext } from '@atlas/contexts/search';

const markerSize = 40;
const icon: any = new Icon({
  iconUrl: `/static/img/marker-highlight.svg`,
  iconSize: new Point(markerSize, markerSize),
  iconAnchor: [markerSize / 2, markerSize * 1.08],
});

export const SelectedAddressMarker = () => {
  const { on } = useContext(AtlasEventsContext);
  const { search } = useContext(SearchContext);

  const [highlightedAddress, setHighlightedAddress] =
    useState<HighlightedAddressState>();

  useEffect(
    () =>
      on('highlightChange', (highlightedAddress) =>
        setHighlightedAddress(highlightedAddress),
      ),
    [on],
  );

  if (
    (highlightedAddress && highlightedAddress.addressCode === search.address) ||
    !search.point
  )
    return null;

  return (
    <Marker
      icon={icon}
      position={search.point}
      zIndexOffset={1001}
      interactive={false}
    />
  );
};
